import withRrcPromoProps from 'viewModel/reward/rewards/RrcPromo/withRrcPromoProps';
import RrcPromo from 'components/Reward/RrcPromo/RrcPromo';

export default withRrcPromoProps(RrcPromo);
